// extracted by extract-css-chunks-webpack-plugin
module.exports = {"rightColumn":"_2B6Guf","feedbackSuccessIcon":"_1vqEfy","textTitle":"FFD938","reviewerEditorWrapper":"p8CuwU","renderToolTip":"_2Q7M_G"};